<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex _bb">
            <p>팝업 배너</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form">

            <ul>
                <li>
                    <label for="title" class="form_li_tit">제목</label>
                    <input id="title" type="text" placeholder="제목을 입력해주세요" v-model="form_state.title" />
                </li>
                <li>
                    <span class="form_li_tit">노출기간</span>
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date"   name="" id="" v-model="form_state.startDate" />
                        </div>
                        <div class="select_date">
                            <input type="date"   name="" id="" v-model="form_state.endDate" />
                        </div>
                    </div>
                </li>
                <li class="file_wrap">
                    <span class="form_li_tit">노출이미지</span>
                    <label for="area_file_popup">
                        <input id="area_file_popup" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">이미지를 등록해주세요.</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                    </label>
                    <div class="file_list">
                        <div class="file_img_m">
                            <img style="max-width: 100%;" :src="state.fileUrl ? state.fileUrl : 'img/no_img.png'"></img>
                        </div>
                    </div>
                </li>
                <li>
                    <label for="title" class="form_li_tit">링크</label>
                    <input id="title" type="text" placeholder="링크를 입력해주세요" v-model="form_state.link" />
                </li>
                <li class="checkbox_wrap _blue_col">
                    <span class="form_li_tit">숨김 버튼 표시</span>
                    <label for="chk">
                        <input id="chk" type="checkbox" v-model="form_state.isSettingClose"  />
                        <em></em>
                        <span>'오늘 하루 안보기' 표시</span>
                    </label>
                </li>
                <li class="checkbox_wrap _blue_col">
                    <span class="form_li_tit">위치</span>
                    <label>
                        <input type="radio" name="location" value="L" v-model="form_state.location" />
                        <em></em>
                        <span>L</span>
                    </label>

                    <label>
                        <input type="radio" name="location" value="M" v-model="form_state.location" />
                        <em></em>
                        <span>M</span>
                    </label>

                    <label>
                        <input type="radio" name="location" value="R" v-model="form_state.location" />
                        <em></em>
                        <span>R</span>
                    </label>
                </li>
            </ul>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">취소</button>

                <button v-if="props.isEdit" class="submit_btn _130 _main_blue" @click="modify">수정</button>
                <button v-else class="submit_btn _130 _main_blue" @click="add">저장</button>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            data: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "modify", "add"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,

                file: null as any,
                fileUrl: null as any,
            });

            const form_state = reactive({
                idx: 0 as number,
                title: "" as string,
                startDate: "" as string,
                endDate: "" as string,
                // file: null as any,
                link: "" as string,
                isSettingClose: false as boolean,
                location: '' as string,
            });

            onMounted(() => {
                if (props.isEdit) {
                    form_state.idx = props.data.idx;
                    form_state.title = props.data.title;
                    form_state.startDate = CommonUtils.dateFormat(props.data.startDate, "-", false);
                    form_state.endDate = CommonUtils.dateFormat(props.data.endDate, "-", false);
                    state.fileUrl = props.data.file;
                    form_state.link = props.data.link;
                    form_state.isSettingClose = props.data.isSettingClose === 1 ? true : false;
                    form_state.location = props.data.location;
                }
            document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => emit("close");

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                let imgUrls = null;
                const reader = new FileReader();
                reader.onload = (ee: any) => {
                    imgUrls = ee.target.result;
                    state.fileUrl = imgUrls;
                    state.file = file;
                };
                reader.readAsDataURL(file);
                target.value = "";
            };

            const add = () => {
                const param: types.ReqBannerPopup = {
                    title: form_state.title,
                    startDate: form_state.startDate,
                    endDate: form_state.endDate,
                    isSettingClose: form_state.isSettingClose ? 1 : 0,
                    location: form_state.location,
                    link: form_state.link,
                    isShow: 0,
                    file: null,
                };
                if (state.file) param.file = state.file;
                emit("add", param);
            };

            const modify = () => {
                const param: types.ReqBannerPopupForModify = {
                    idx: form_state.idx,
                    title: form_state.title,
                    startDate: form_state.startDate,
                    endDate: form_state.endDate,
                    isSettingClose: form_state.isSettingClose ? 1 : 0,
                    location: form_state.location,
                    link: form_state.link,
                    isShow: props.data.isShow,
                    file: null,
                };
                if (state.file) param.file = state.file;
                emit("modify", param);                
            };

            return { state, form_state, closeModal, props, CommonUtils, handleFiles, add, modify };
        },
    };
</script>
